// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreateDashboardModalFirstStep {
  display: flex;
  flex-direction: column;
  row-gap: var(--spacing_unit_6);
}
.CreateDashboardModalFirstStep .CreateDashboardModalFirstStep-label {
  display: inline-block;
  font-size: 12px;
  color: var(--color_neutral_800);
  margin-bottom: var(--spacing_unit_2);
}
.CreateDashboardModalFirstStep .CreateDashboardModalFirstStep-usecases-grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: var(--spacing_unit_3);
  gap: var(--spacing_unit_3);
}
.CreateDashboardModalFirstStep .CreateDashboardModalFirstStep-footer {
  display: flex;
  justify-content: flex-end;
  column-gap: var(--spacing_unit_4);
}`, "",{"version":3,"sources":["webpack://./src/components/DashboardModals/CreateDashboardModal/components/CreateDashboardModalFirstStep/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;AACF;AACE;EACE,qBAAA;EACA,eAAA;EACA,+BAAA;EACA,oCAAA;AACJ;AAEE;EACE,aAAA;EACA,8BAAA;EACA,+BAAA;EAAA,0BAAA;AAAJ;AAGE;EACE,aAAA;EACA,yBAAA;EACA,iCAAA;AADJ","sourcesContent":[".CreateDashboardModalFirstStep {\n  display: flex;\n  flex-direction: column;\n  row-gap: var(--spacing_unit_6);\n\n  .CreateDashboardModalFirstStep-label {\n    display: inline-block;\n    font-size: 12px;\n    color: var(--color_neutral_800);\n    margin-bottom: var(--spacing_unit_2);\n  }\n\n  .CreateDashboardModalFirstStep-usecases-grid-container {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: var(--spacing_unit_3);\n  }\n\n  .CreateDashboardModalFirstStep-footer {\n    display: flex;\n    justify-content: flex-end;\n    column-gap: var(--spacing_unit_4);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
